import React from 'react'

const Content = ({contentAsProp}) => {
    return (
        <div className="mainContentWrapper vh-100">
            {contentAsProp}
        </div> 
    )
}

export default Content
